import { useTranslation } from 'react-i18next';
import { shopPrefix } from '../../config';
import { SOURCE_PRODUCT_GROUPS } from '../../store/constants';
import { globalErrorResponse, TYPE_WARNING } from '../../shared/notification/actions';
import { http } from '../axios';
import {
    isExcludeProductSelection,
    isIncludeProductSelection,
    ProductSelection
} from '../../shared/product-selection/ProductSelectionTypes';
import { nothingSelected } from '../../shared/product-selection/ProductSelectionUtils';
import { showNotification } from '../../shared/notification/toastNotification';
import { ProductFilter } from '../../store/api';

type UseRemoveFromGroupBulkParams = {
    productGroupId: string;
    onSuccess: () => void;
    productSelection: ProductSelection;
    productFilter: ProductFilter;
};

export function useRemoveFromGroupBulk({
    productGroupId,
    onSuccess,
    productSelection,
    productFilter
}: UseRemoveFromGroupBulkParams) {
    const { t } = useTranslation();

    return async () => {
        if (nothingSelected(productSelection)) {
            throw new Error(t('notifications.nothingSelected.error'));
        }

        let requestdata = {
            pathParams: {},
            data: {}
        };

        try {
            requestdata = {
                pathParams: { productGroupId },
                data: {
                    ...requestdata.data,
                    amount: 0,
                    source: SOURCE_PRODUCT_GROUPS,
                    sourceId: productGroupId
                }
            };

            if (isIncludeProductSelection(productSelection)) {
                requestdata = {
                    ...requestdata,
                    pathParams: { ...requestdata.pathParams, kind: 'ids' },
                    data: {
                        ...requestdata.data,
                        lineItemKeys: productSelection.included
                    }
                };
            } else if (isExcludeProductSelection(productSelection)) {
                requestdata = {
                    ...requestdata,
                    pathParams: { ...requestdata.pathParams, kind: 'filter' },
                    data: {
                        ...requestdata.data,
                        filterRequest: productFilter,
                        excludedLineItemKeys: productSelection.excluded
                    }
                };
            }
        } catch (error) {
            showNotification(t('notifications.copyAmountChangeCartBulk.warning'), TYPE_WARNING);
            return;
        }

        await http
            .put(`${shopPrefix}/v1/librarymanaged/productgroups/:productGroupId/bulk/:kind/remove`, requestdata.data, {
                pathParams: requestdata.pathParams
            })
            .then(() => {
                showNotification(t('marketing.productGroups.warnings.removeSelectedProducts'));
                onSuccess();
            })
            .catch(error => {
                globalErrorResponse(error);
            });
    };
}
